import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-sm-12 col-lg-8 col-xl-4 transportation-tickets-container__forward-back m-1 d-flex flex-column align-items-center justify-content-center p-0"
}
const _hoisted_2 = {
  key: 1,
  class: "col-4 transportation-tickets-container__forward-back m-1 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "transportation-tickets-container__forward-back__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransportationTicketCardComponent = _resolveComponent("TransportationTicketCardComponent")!

  return (_ctx.isSelected)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_TransportationTicketCardComponent, {
          transportation: _ctx.data,
          "trip-date": _ctx.tripDate,
          "ticket-title": _ctx.title,
          "route-string": _ctx.route
        }, null, 8, ["transportation", "trip-date", "ticket-title", "route-string"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.displayProps.imgUrl,
          alt: "",
          class: "transportation-tickets-container__forward-back__arrow"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.displayProps.placeholder)), 1)
      ]))
}